import React, { useState } from "react";
import Breadcrumbs from "../../Breadcrumbs/Breadcrumbs.js";
import ScientificSlider from "./ScientificSlider/ScientificSlider.js";
import useSEO from "../../hooks/useSEO.js";
import seoConfig from "../../hooks/seoConfig.js";

import imageSR_1 from "../../../images/scientific-research/Nauchnyye_issledovaniya-1.jpeg";
import imageSR_2 from "../../../images/scientific-research/Nauchnyye_issledovaniya-2.jpeg";
import imageSR_3 from "../../../images/scientific-research/Nauchnyye_issledovaniya-3.jpeg";
import imageSR_4 from "../../../images/scientific-research/Nauchnyye_issledovaniya-4.jpeg";
import imageSR_5 from "../../../images/scientific-research/Nauchnyye_issledovaniya-5.jpeg";
import imageSR_6 from "../../../images/scientific-research/Nauchnyye_issledovaniya-6.jpeg";
import imageSR_7 from "../../../images/scientific-research/Nauchnyye_issledovaniya-7.jpeg";
import imageSR_8 from "../../../images/scientific-research/Nauchnyye_issledovaniya-8.jpeg";
import imageSR_9 from "../../../images/scientific-research/Nauchnyye_issledovaniya-9.jpeg";
import imageSR_10 from "../../../images/scientific-research/Nauchnyye_issledovaniya-10.jpeg";

const scientific = [
  {
    text: "Научные исследования",
    image: imageSR_1,
  },
  {
    text: "Научные исследования",
    image: imageSR_2,
  },
  {
    text: "Научные исследования",
    image: imageSR_3,
  },
  {
    text: "Научные исследования",
    image: imageSR_4,
  },
  {
    text: "Научные исследования",
    image: imageSR_5,
  },
  {
    text: "Научные исследования",
    image: imageSR_6,
  },
  {
    text: "Научные исследования",
    image: imageSR_7,
  },
  {
    text: "Научные исследования",
    image: imageSR_8,
  },
  {
    text: "Научные исследования",
    image: imageSR_9,
  },
  {
    text: "Научные исследования",
    image: imageSR_10,
  },
];

export default function ScientificResearch() {
  useSEO(seoConfig.scientificResearch);

  const [currentIndex, setCurrentIndex] = useState(0);

  const handleNext = () => {
    if (currentIndex < scientific.length - 1) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  const handlePrev = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  const currentSlide = scientific[currentIndex];
  return (
    <section className="licenses antiCorruption development">
      <Breadcrumbs />
      <h1 className="contacts__title history__title licenses__title development__title">
        Научные исследования
      </h1>

      <button
        className="prevention__left employees__left history__left scientific__left"
        onClick={handlePrev}
      ></button>

      <button
        className="prevention__right employees__right history__right scientific__right"
        onClick={handleNext}
      ></button>

      <ScientificSlider text={currentSlide?.text} image={currentSlide.image} />
    </section>
  );
}
